'use client';

import { baseTheme } from 'shared/config/theme';

export const theme = baseTheme;
